import React from "react";
import {
  FaEnvelope,
  FaMapMarker,
  FaPhoneAlt,
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaLinkedin,
  FaYoutube,
} from "react-icons/fa";
import logo1 from "../assets/img/rsilogo.png";
import { FaX } from "react-icons/fa6";

const Footer = () => {
  return (
    <footer id="footer" className="bg-primary-light pt-8 pb-10">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-4 gap-8 lg:gap-20 px-4 md:px-0">
        <div className="logo col-span-1 max-[450px]:block md:col-span-1">
          <div className="flex items-center mb-4 lg:ml-[-0.2vw] lg:w-[30vw]">
            <img
              src={logo1}
              alt="RSI Fibre Solutions Logo"
              width="35"
              className="mr-3 rounded-[0.3rem]"
            />
            <h3 className="text-sm font-semibold md:text-lg md:mr-16">
              Rehoboth Standard International
            </h3>
          </div>
          <p className="mb-4 text-sm">
            A strong connection is the foundation of every great project. Choose
            quality cables, expert support, and dependable delivery.
          </p>
          <h3 className="text-lg font-semibold mb-2">Get Social</h3>
          <div className="flex space-x-4 text-lg text-primary">
            <a href="https://www.instagram.com/rehobothsil">
              <FaInstagram />
            </a>
            <a href="https://www.facebook.com/share/1H6BhR141Y/">
              <FaFacebook />
            </a>
            <a href="https://www.linkedin.com/company/rehoboth-sil/">
              <FaLinkedin />
            </a>
            <a href="https://x.com/RehobothSIL?t=UDe5rRQt_nT0owXdzH6f2A&s=09">
              <FaX />
            </a>
            <a href="https://www.youtube.com/@rehoboth-sil">
              <FaYoutube />
            </a>
          </div>
        </div>
        <div className="about ml-[0.5rem]">
          <h3 className="text-lg font-semibold mb-4">Office Hours</h3>
          <ul className="space-y-2">
            <li>Monday - Friday</li>
            <li>8:00 AM - 6:00 PM</li>
          </ul>
        </div>
        <div className="support">
          <h3 className="text-lg font-semibold mb-4">Our Services</h3>
          <ul className="space-y-2 text-sm">
            <li>On-site delivery services.</li>

            <li>Quality cables and wires supply.</li>
            <li>Custom electrical cable options.</li>
            <li>Project distributorship and supply partnership.</li>
            <li>Expert technical support and consultation.</li>
            <li>Certification of industry-standard products.</li>
          </ul>
        </div>
        <div className="contact">
          <h3 className="text-lg font-semibold mb-4">Get in Touch</h3>
          <ul className="space-y-4 text-sm">
            <li className="flex items-center">
              <div className="contact-icon mr-3">
                <FaEnvelope />
              </div>
              <div>
                <h4>Email</h4>
                <h4>
                  <a href="mailto:info@rehobothstandardcables.com">
                    info@rehobothstandardcables.com
                  </a>
                </h4>
              </div>
            </li>
            <li className="flex items-center">
              <div className="contact-icon mr-3">
                <FaPhoneAlt />
              </div>
              <div>
                <h4>Phone</h4>
                <p>
                  <a href="tel:+2348033607144">+2348033607144</a>
                </p>
              </div>
            </li>
            <li className="flex items-center">
              <div className="contact-icon mr-3">
                <FaMapMarker />
              </div>
              <div>
                <h4 className="mb-2">Location</h4>
                <a
                  href="https://maps.app.goo.gl/oAXg6xe25W7Ui1qz5"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 hover:underline cursor-pointer"
                >
                  <p className="text-gray-700">
                    1st floor dabino house, Yakubu Gowon way, Kaduna, Nigeria
                  </p>
                </a>
              </div>
            </li>
            <li className="flex items-center">
              <div className="contact-icon mr-3">
                <FaMapMarker />
              </div>
              <div>
                <a
                  href="https://maps.app.goo.gl/EyYoRLvbvRn5LQw27?g_st=aw"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 hover:underline cursor-pointer"
                >
                  <p className="text-gray-700">
                    Plot 9 Ladipo Oluwole off Adeniyi Jones, Ikeja. Lagos,
                    Nigeria.
                  </p>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom text-center mt-8 max-[450px]:block">
        <p className="mb-2 text-sm">
          &copy; 2025 <span className="text-primary">Rehoboth</span> All rights
          reserved
        </p>
        <p className="text-sm">Terms and conditions apply</p>
      </div>
    </footer>
  );
};

export default Footer;
